import { useTranslation } from "react-i18next";

export default function Testimonial() {
  const { t } = useTranslation();

  return (
    <section id="testimonial" className="bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-2/5 w-full">
            <div className="rounded-3xl overflow-hidden h-72 md:h-96 bg-accent-100">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20European%20businessman%20portrait%20in%20modern%20minimalist%20white%20office%20with%20green%20plants%2C%20clean%20corporate%20editorial%20photography%2C%20soft%20natural%20daylight%2C%20confident%20friendly%20expression%2C%20contemporary%20professional%20style&width=700&height=800&seq=testimonial-v2-person&orientation=portrait"
                alt="Hipobuy Spreadsheet témoignage utilisateur"
                title="Hipobuy Spreadsheet - Témoignage"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <span className="text-xs text-foreground-500 uppercase tracking-wider font-medium">
              {t("testimonial.tag")}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mt-2 leading-tight">
              {t("testimonial.title.line1")}
              <br />
              <span className="text-foreground-400">{t("testimonial.title.line2")}</span>
            </h2>

            <blockquote className="mt-8 md:mt-10 text-foreground-700 text-sm md:text-base leading-relaxed max-w-lg">
              &ldquo;{t("testimonial.quote")}&rdquo;
            </blockquote>

            <div className="mt-6">
              <p className="text-foreground-900 font-semibold text-sm">
                — {t("testimonial.author")}
              </p>
              <p className="text-foreground-500 text-xs mt-0.5">
                {t("testimonial.company")}
              </p>
            </div>

            <div className="flex items-center gap-3 mt-8">
              <button className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:bg-foreground-100 transition-colors" aria-label={t("testimonial.prev")}>
                <i className="ri-arrow-left-line"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-white hover:bg-foreground-800 transition-colors" aria-label={t("testimonial.next")}>
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}